module.exports = __webpack_public_path__ + "static/media/logo-maranhaozinho.58a5b116.png";